import { Container } from 'react-bootstrap';
import { FaPhone, FaEnvelope, FaUser } from 'react-icons/fa';
import '../style/TopBar.css';

const TopBar = () => {
    // Definisikan email, subjek, dan isi email di sini agar mudah diubah (bisa di bilang sebagai template)
    const emailAddress = 'info@syailendra-auction.com';
    const emailSubject = 'Pertanyaan Mengenai Lelang';
    const emailBody = 'Halo Syailendra Auction, saya ingin bertanya mengenai...';

    // Membuat URL khusus untuk Gmail
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${emailAddress}&su=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;

    return (
        <div className="top-bar">
            {/* Menambahkan kelas Bootstrap untuk flexbox langsung ke Container */}
            <Container className="d-flex justify-content-center">
                {/* Div ini sekarang hanya untuk mengelompokkan link */}
                <div className="top-bar-wrapper">
                    <a href="https://api.whatsapp.com/send/?phone=6281233940758&text&type=phone_number&app_absent=0" className="top-bar-link">
                        <FaPhone className="top-bar-icon" /> +6281-2339-40758
                    </a>
                    <a href={gmailUrl} className="top-bar-link" target="_blank" rel="noopener noreferrer">
                        <FaEnvelope className="top-bar-icon" /> info@syailendra-auction.com
                    </a>
                    <a href="https://bid.syailendra-auction.com/login" className="top-bar-link">
                        <FaUser className="top-bar-icon" /> Sign Up / Log In
                    </a>
                </div>
            </Container>
        </div>
    );
};

export default TopBar;
